import React from 'react';

const AWS_CloudWatch = () => {
  return (
    <div>
      <h1>AWS_CloudWatch</h1>
      <p>This is the AWS_CloudWatch component.</p>
    </div>
  );
};

export default AWS_CloudWatch;
